import React, { Component } from 'react';

class OpinionModal extends Component
{
    render()
    {
        return (
            <div className="modal fade" id={ "opinion"+this.props.index } tabIndex="-1" role="dialog" aria-labelledby={ "#opinionsTitle"+this.props.index } aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-white">
                            <span className="modal-title h5" id={ "opinionsTitle"+this.props.index }>{this.props.opinion.source}</span>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mx-2 row">
                                <span className="h6 text-muted col-4">Commentaire</span>
                                <span className="col-8">{ this.props.opinion.comment }</span>
                            </div>
                            {this.props.opinion.contract_number_ctsce &&                  
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-4">Commentaire de clôture</span>
                                    <span className="col-8">{ this.props.opinion.contract_number_ctsce }</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default OpinionModal;



// WEBPACK FOOTER //
// ./src/Components/Opinion/OpinionModal.js